module.exports = __webpack_public_path__ + "static/img/5.7f22680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimages/5.png
// module id = RG1a
// module chunks = 1